module.exports = "<button *ngIf=\"visible && linkText\"\n  type=\"button\"\n  class=\"app-banner clickable\"\n  [ngClass]=\"type\"\n  (click)=\"linkClick.emit()\">\n  <span class=\"banner-message\">{{ message }}</span>\n  <span class=\"banner-link\">{{ linkText }}</span>\n</button>\n\n<div *ngIf=\"visible && !linkText\"\n  class=\"app-banner\"\n  [ngClass]=\"type\">\n  <span class=\"banner-message\">{{ message }}</span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/banner.component.html
// module id = ./src/app/shared/banner.component.html
// module chunks = main